import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { selectDeckPile } from '../ActiveGame/selectors';
import CardFace from '../Card/CardFace';
import { Slot } from '../Card/styled';
import { PlainButton } from '../Controls';
import { DECK } from '../ActiveGame/contextMenuTypes';
import { setContextMenu } from '../ActiveGame/actions';
import useCardDrag from '../Drag/useCardDrag';
import { anchors } from '../Motion/anchorNames';
import { selectDrawOwed } from './selectors';
import { DECK_TO_HAND } from './constants';
import { draw } from './actions';
import { DeckStack } from './styled';

/**
 * A player's deck. When your turn's draw is owed, tapping it draws, and so does dragging it onto your hand (the hand
 * lights up for it), the same as the Draw a card button; otherwise tapping it opens its menu. It looks as thick as
 * it is (DeckStack).
 */
const Deck = ({ userId }) => {
  const dispatch = useDispatch();
  const deckPile = useSelector((state) => selectDeckPile(state, { userId }));
  const owed = useSelector((state) => selectDrawOwed(state, { userId }));
  const canDraw = !!owed && !owed.reason && !owed.drawing;
  const { bind, ghost } = useCardDrag({
    enabled: canDraw,
    place: anchors.deck(userId),
    lift: () => ({ kind: DECK_TO_HAND }),
    settledBy: deckPile,
    staysWhileLifted: true,
  });

  if (!deckPile || !deckPile.get('count')) {
    return <Slot aria-label="Empty deck" />;
  }

  return (
    <>
      <PlainButton
        {...bind}
        onClick={() => dispatch(canDraw ? draw() : setContextMenu(DECK, userId))}
        aria-label={`Deck, ${deckPile.get('count')} cards`}
      >
        <DeckStack $count={deckPile.get('count')}><CardFace count={deckPile.get('count')} /></DeckStack>
      </PlainButton>
      {ghost(<CardFace />)}
    </>
  );
};

Deck.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default Deck;
